document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector('.quickview-modal');

  document.querySelectorAll('.quickview-button').forEach(button => {
    button.addEventListener('click', function () {
      modal.style.display = 'flex';

      // Swiper
      new Swiper('.quickview-swiper', {
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
    });
  });

  document.querySelector('.quickview-close')?.addEventListener('click', () => {
    modal.style.display = 'none';
  });
});
